import React from 'react';
import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

export default function OptionButton({ label, selected, onClick, disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "w-full px-5 py-4 rounded-lg border text-left transition-all duration-150",
        "flex items-center justify-between gap-4",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        selected
          ? "border-primary bg-primary-muted text-foreground shadow-sm"
          : "border-border bg-background text-foreground hover:border-primary/50 hover:bg-secondary",
        disabled && "opacity-50 cursor-not-allowed"
      )}
    >
      <span className="font-medium">{label}</span>
      {selected && (
        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary flex items-center justify-center">
          <Check className="w-4 h-4 text-primary-foreground" />
        </span>
      )}
    </button>
  );
}